import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import deepMapAudio from '../assets/deep-map.mp3';

const DeepMap: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          Deep Map
        </Typography>

        <Box sx={{ my: 4 }}>
          <audio controls style={{ width: '100%' }}>
            <source src={deepMapAudio} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        </Box>

        <Button component={RouterLink} to="/" variant="contained">
          Back to Home
        </Button>
      </Box>
    </Container>
  );
};

export default DeepMap;
